// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React from 'react';

import { Alignment } from '@powdr/constants';
import { componentFactory } from '@powdr/utils';

import { StyledUiForm } from './styles';

export const UiForm = ({
  alignment = Alignment.LEFT,
  parentColorProfile = null,
  relationships,
}) => (
  <StyledUiForm $alignment={alignment || Alignment.LEFT}>
    {(componentFactory(relationships?.formService, parentColorProfile))}
  </StyledUiForm>
);

UiForm.propTypes = {
  alignment: PropTypes.string,
  relationships: PropTypes.shape().isRequired,
  parentColorProfile: PropTypes.string,
};
